/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState, useRef, useCallback, useEffect} from 'react';
import ic_my_orgs_svg from '../../static/img/content/ic-my-orgs.svg'
import ic_no_data_svg from '../../static/img/content/no-data-illustration.svg'
import ic_search_svg from '../../static/img/utils/ic-search.svg'
import MainContentSummaryRowComponent from "./MainContentSummaryRowComponent";
import {useQuery} from "@tanstack/react-query";
import useHookSearch from "../../hook/SearchHook";
import MainContentPlaceholderComponent from "./MainContentPlaceholderComponent";
import OrganizationWizardComponent from "./Organization/OrganizationWizardComponent";
import {useAuthSession} from "../../context/AuthSessionContext";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import MainWelcomeComponent from "./MainWelcomeComponent";
import {get_primary_email} from "../../service/common";
import MainNoDefaultEmailComponent from "./MainNoDefaultEmailComponent";
import AttentionBar from "./AttentionBar";
import {useAlertContext} from "../../context/AlertContext";


const MainContentSummary = ({doRefreshHeaderOrgList}) => {
    const alert = useAlertContext();
    const {t} = useTranslation();
    // const [open, node] = useToggle();
    const {OrganizationAPI} = useOrganizationApi();
    const {useCheckSession} = useAuthSession();
    const [offset, setOffset] = useState(0);
    const [openWizard, setOpenWizard] = useState(false);
    const [searchOrg, setSearchOrg] = useState('');
    const [refresh, setRefresh] = useState(0);
    const [refreshCount, setRefreshCount] = useState(0);
    // const [sortType, setSortType] = useState('createdDate')
    // const [sortTypeName, setSortTypeName] = useState('@Created Date@')
    const [append, setAppend] = useState(true);
    // const alert = useAlertContext();
    const [hasEmail, setHasEmail] = useState(true);
    const { data:count, isLoading } = useQuery({
        queryKey: ["get_org_list_count", refresh, refreshCount],
        queryFn: async () => {
            const res = await OrganizationAPI.get('organization/count');
            return res.result;
        }
    });

    const { result:searchResult, hasMore, error:searchError, loading, setResult} = useHookSearch('organization-center/dashboard', searchOrg, offset, refresh, append)

    const observer = useRef()

    const lastMarkedElement = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setAppend(true);
                setOffset(prevOffset=> prevOffset + 5)
            }
        });
        if (node) observer.current.observe(node)
    }, [loading, hasMore])

    // const onSelectSort = (name, value) => {
    //     setSortType(value);
    //     setSortTypeName(name);
    // }

    const updateSearchQuery = (value) => {
        setResult([]);
        setSearchOrg(value);
        setAppend(false);
        setOffset(0);
    }

    const onWizardDialogClose = () => {
        setOpenWizard(false);
        let new_org_list = JSON.parse(window.localStorage.getItem('new_org_list')) || [];
        window.localStorage.removeItem('new_org_list');
        if (new_org_list.length > 0) {
            new_org_list.map(async (id) => {
                const new_org = await OrganizationAPI.get(`organization-center/dashboard/${id}`, null, null);
                new_org.result['new'] = true;
                setResult(prev=>{
                    return [new_org.result, ...prev]
                });
                return new_org.result;
            });
        }
    }

    const onCreateOrgPreCheck = async () => {
        const count = await OrganizationAPI.get('organization/count', null);
        if (count?.result > window._env_.REACT_APP_MAX_ORGANIZATION) {
            alert(true, 'error', 1060033, 'You have reached the maximum limit of 50 organizations for your QNAP ID.');
            return;
        }
        setOpenWizard(true);
    }

    const checkCurrentUserEamil = () => {
        const intervalID = setInterval(()=>{
            const localUser = JSON.parse(window.localStorage.getItem('currentUser'));
            if (!!localUser) {
                setHasEmail(!!get_primary_email(localUser));
                clearInterval(intervalID);
            }
        }, 200);
        return intervalID;
    }

    useCheckSession();

    useEffect(()=>{
        const id = checkCurrentUserEamil();

        return () => {clearInterval(id)}
    }, [])

    return (
        <>
            { hasEmail && isLoading && <MainContentPlaceholderComponent />}
            { !hasEmail && !isLoading && <MainNoDefaultEmailComponent />}
            { hasEmail && !isLoading && count <= 0 && <MainWelcomeComponent doRefresh={doRefreshHeaderOrgList} /> }
            { hasEmail && !isLoading && count > 0 &&
                <div className="content content-page">
                    <div className="content-title">
                        <div className="title-ic"><img src={ic_my_orgs_svg} alt=""/></div>
                        <div className="title-label">{t('@My Organization@')}</div>
                    </div>
                    <AttentionBar organizations={searchResult} />
                    <div className="toolbar">
                        <div className="col-wrapper">
                            <div className="col-left">
                                <div className="amount-info fs14 !ml-10">{t('@Organization@')}:
                                    <span className="hi-light !pl-8">{count}</span>
                                </div>
                                <div className="func-divide !ml-16 !mr-16" />
                                <div className="q-btn-group">
                                    <button type="button" className="q-btn q-btn-primary q-btn-small q-btn-round-corner" onClick={async ()=> await onCreateOrgPreCheck()}>
                                        {t('@Create organization@')}
                                    </button>
                                </div>
                            </div>
                            <div className="col-right">
                                <div className="comp-search">
                                    <img src={ic_search_svg} alt=""/>
                                    <div className="comp-input">
                                        <input type="text" placeholder={t("@Search@") + ' ' + t("@Organization@")} value={searchOrg}
                                               onChange={(e)=>updateSearchQuery(e.target.value)}/>
                                    </div>
                                </div>
                                {/* Uncomment following if sort options are needed. Remember to update backend api as well  */}
                                {/*<div className="func-divide !ml-16 !mr-16" />*/}
                                {/*<div className={`comp-select summary-filter auto-width drop-adjustable drop-align-right ${open==='show' ? 'active' : ''}`} ref={node}>*/}
                                {/*    <div className="select-toggle">*/}
                                {/*        <span className="select-label">{t(sortTypeName)}</span>*/}
                                {/*    </div>*/}
                                {/*    <div className={`comp-dropdown comp-select-dropdown ${open}`}>*/}
                                {/*        <ul className="comp-dropdown-menu">*/}
                                {/*            <li className="section">*/}
                                {/*                <div className="section-items selection" onClick={()=>onSelectSort('@Created Date@', 'createdDate')}>{t('@Created Date@')}</div>*/}
                                {/*                <div className="section-items selection" onClick={()=>onSelectSort('@Organization name@', 'orgName')}>{t('@Organization name@')}</div>*/}
                                {/*                <div className="section-items selection" onClick={()=>onSelectSort('@Created By@', 'createdBy')}>{t('@Created By@')}</div>*/}
                                {/*            </li>*/}
                                {/*        </ul>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                    <div className="content-wrapper page-wrapper shadowtop-scroll-content shadowtop-overlay-scroll">
                        {/* Doing Infinity Scroll */}
                        {/*{searchResult.filter((o)=>{return o.name.match(new RegExp(searchOrg, 'i'))}).map((org, index)=>{*/}
                        {!loading && searchResult?.length <= 0 && (
                            <div className="flexbox-table">
                                <div className="flexbox-tbody overlay-scroll os-host-flexbox">
                                    <div className="no-data-screen">
                                        <div className="no-data-info">
                                            <div className="no-data-img"><img src={ic_no_data_svg} alt="" />
                                            </div>
                                            <div className="no-data-msg">{t('@No Result@')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        }
                        {searchResult.map((org, index)=>{
                            if (searchResult.length === index + 1) {
                                return <MainContentSummaryRowComponent ref={lastMarkedElement} organization={org} key={org.organization_id} setOrgList={setResult} setOrgCount={setRefreshCount} doRefreshHeaderOrgList={doRefreshHeaderOrgList} updateSummary={()=>setRefresh(prev=>prev+1)}/>
                            }
                            else {
                                return <MainContentSummaryRowComponent organization={org} key={org.organization_id} setOrgList={setResult} setOrgCount={setRefreshCount} doRefreshHeaderOrgList={doRefreshHeaderOrgList} updateSummary={()=>setRefresh(prev=>prev+1)}/>
                            }
                        })}
                        <div>{loading && <MainContentPlaceholderComponent />} </div>
                        <div>{searchError && console.log(searchError)}</div>
                    </div>

                    {openWizard && <OrganizationWizardComponent openModal={openWizard} closeModal={onWizardDialogClose} doRefresh={setRefresh} setOrgList={setResult}/>}

                </div>
            }
        </>
    );
};

export default MainContentSummary;